export enum GroupingType {
  Campaigns = 'campaigns',
  CampaignTypes = 'campaign_types',
  WebCampaigns = 'web_campaigns',
  WebSources = 'web_sources',
  WebMediums = 'web_mediums',
}
